export { Illustration, type IllustrationProps, ILLUSTRATION_NAMES, type IllustrationName } from './Illustration'
